import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import styled, { css } from 'styled-components';
import { map } from '../breakpoint';
import { p, m, mt } from '../spacing';
import { isList, isValidSpacing } from '../utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StackWrapper = styled(_ref => {
  let {
    space,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
}).attrs({
  'data-mesh-component': 'STACK'
})`
  /* If stack is set to be a ul or ol we need to reset the default styling */

  ${_ref2 => {
  let {
    as
  } = _ref2;
  return as && isList(as) && css`
      ${m(0)};
      ${p(0)};
      list-style-type: none;
    `;
}}

  > * {
    &:not(:first-child) {
      ${_ref3 => {
  let {
    space
  } = _ref3;
  return map(space, val => isValidSpacing(val) && css`
              ${mt(val)};
            `);
}};
    }
  }
`;
export const Stack = props => {
  const {
    children,
    space = 0,
    ...otherProps
  } = props;
  const ChildComponent = isList(props.as) ? 'li' : 'div';
  return /*#__PURE__*/_jsx(StackWrapper, {
    space: space,
    ...otherProps,
    children: Children.map(flattenChildren(children), child => {
      if (/*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/_jsx(ChildComponent, {
          children: child
        });
      }
      return null;
    })
  });
};
Stack.displayName = 'Stack';